import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchBusinessInsightsMetrics } from '../../predict/src/core/api/performance-metrics';
import { queryClient } from '../core/queryClient';

type FetchBusinessInsightsMetricsResult = Awaited<ReturnType<typeof fetchBusinessInsightsMetrics>>;
type BusinessInsightsMetricsQueryOptions = Omit<
  QueryObserverOptions<FetchBusinessInsightsMetricsResult>,
  'queryKey' | 'queryFn'
>;

export const businessInsightsMetricsQueryKey = (organisationId: string, workspaceId: string) => [
  'businessInsightsMetrics',
  organisationId,
  workspaceId
];

export const businessInsightsMetricsQuery = (
  workspaceId: string,
  organisationId: string,
  options?: BusinessInsightsMetricsQueryOptions
): QueryObserver<FetchBusinessInsightsMetricsResult> =>
  new QueryObserver<FetchBusinessInsightsMetricsResult>(queryClient, {
    queryKey: businessInsightsMetricsQueryKey(organisationId, workspaceId),
    queryFn: () => fetchBusinessInsightsMetrics(workspaceId, organisationId),
    ...options
  });

export const comparisonMetricsQueryKey = (organisationId: string, workspaceId: string, forecastId: string) => [
  'comparisonMetrics',
  organisationId,
  workspaceId,
  forecastId
];

export const comparisonMetricsQuery = (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  options?: BusinessInsightsMetricsQueryOptions
): QueryObserver<FetchBusinessInsightsMetricsResult> =>
  new QueryObserver<FetchBusinessInsightsMetricsResult>(queryClient, {
    queryKey: comparisonMetricsQueryKey(organisationId, workspaceId, forecastId),
    queryFn: () => fetchBusinessInsightsMetrics(workspaceId, organisationId, { comparison_forecast_id: forecastId }),
    enabled: !!forecastId,
    ...options
  });
